import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class UserMigrationStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      email: null,
      firstName: null,
      lastName: null,
      reference: null,
      showModal: false
    };
    super('userMigration', initialState, {
      useLocalStorage: false
    });

    this.updateState({
      ...initialState
    });
  }

  async setupEvents() {
    this.on(constants.EVENTS.LEGACY_MIGRATION.DETECTED, (data) => {
      this.state.email = data.email;
      this.state.firstName = data.firstName;
      this.state.lastName = data.lastName;
      this.state.reference = data.reference;
      this.state.showModal = true;
    });

    this.on(constants.EVENTS.LEGACY_MIGRATION.MIGRATION_COMPLETE, () => {
      this.updateState({ ...this.initialState });
    });

    this.on(constants.EVENTS.LEGACY_MIGRATION.MIGRATION_FAILED, () => {
      this.updateState({ ...this.initialState });
    });
  }
}

export default UserMigrationStore;
